import { useEffect, useRef, useState } from 'react';

export function useDelayedToggle(initialState: boolean, offDelay = 0, onDelay = 0): boolean {
  const [state, setState] = useState(initialState);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(
      () => {
        setState(initialState);
      },
      initialState ? onDelay : offDelay,
    );
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [initialState, onDelay, offDelay]);

  return state;
}
